import { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Form,
  Table,
  Button,
  Modal,
} from "react-bootstrap";

import AdminHeader from "./AdminHeader";
import {
  doc,
  getDoc,
  updateDoc,
  serverTimestamp,
  deleteField,
} from "firebase/firestore";

import { db } from "./config";

import {
  decryptValue,
  encryptValue,
} from "./utils/crypto";


function History() {
  const currentYear = new Date().getFullYear();

  const [year, setYear] = useState(currentYear);
  const [month, setMonth] = useState("jan");
  const [search, setSearch] = useState("");

  const [showModal, setShowModal] = useState(false);

  const [selected, setSelected] = useState(null);

  const [editNumber, setEditNumber] = useState("");
  const [saving, setSaving] = useState(false);

  const months = [
    { label: "January", value: "jan" },
    { label: "February", value: "feb" },
    { label: "March", value: "mar" },
    { label: "April", value: "apr" },
    { label: "May", value: "may" },
    { label: "June", value: "jun" },
    { label: "July", value: "jul" },
    { label: "August", value: "aug" },
    { label: "September", value: "sep" },
    { label: "October", value: "oct" },
    { label: "November", value: "nov" },
    { label: "December", value: "dec" },
  ];

  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchHistory = async () => {

    try {

      setLoading(true);

      const docRef = doc(
        db,
        "chart_data",
        year.toString()
      );

      const snapshot = await getDoc(docRef);

      if (!snapshot.exists()) {
        setRecords([]);
        setLoading(false);
        return;
      }

      const data = snapshot.data();

      const monthData = data?.[month] || {};

      const formatted = Object.entries(monthData)
        .map(([day, item]) => {

          let value = "";

          try {

            value = decryptValue(item.number);

          } catch {

            value = item.number;

          }

          return {

            day,

            value,

            time: item.time?.toDate
              ? item.time.toDate()
              : null,

          };

        })
        .sort(
          (a, b) => Number(b.day) - Number(a.day)
        );

      setRecords(formatted);

    } catch (err) {

      console.log(err);

    }

    setLoading(false);

  };

  useEffect(() => {

    fetchHistory();

  }, [year, month]);

  const filtered = records.filter((item) => {

    if (!search) return true;

    return (

      item.day.toString().includes(search) ||

      item.value.includes(search)

    );

  });


  const handleSave = async () => {

    if (editNumber.length !== 2) {
      alert("Number must contain exactly 2 digits.");
      return;
    }

    if (editNumber === "00") {
      alert("00 is not allowed.");
      return;
    }

    const password = prompt(
      "Enter Override Password"
    );

    if (password !== "123456") {
      alert("Invalid Password");
      return;
    }

    try {

      setSaving(true);

      const docRef = doc(
        db,
        "chart_data",
        year.toString()
      );

      await updateDoc(docRef, {

        [`${month}.${selected.day}`]: {

          number: encryptValue(editNumber),

          time: serverTimestamp(),

        },

      });

      await fetchHistory();

      setShowModal(false);

      alert("Updated Successfully");

    } catch (err) {

      console.log(err);

      alert("Failed to update");

    }

    setSaving(false);

  };

  const handleDelete = async () => {

    const password = prompt(
      "Enter Override Password"
    );

    if (password !== "123456") {
      alert("Invalid Password");
      return;
    }

    const confirmDelete = window.confirm(
      `Delete record for ${selected.day}?`
    );

    if (!confirmDelete) return;

    try {

      setSaving(true);

      const docRef = doc(
        db,
        "chart_data",
        year.toString()
      );

      await updateDoc(docRef, {

        [`${month}.${selected.day}`]:
          deleteField(),

      });

      await fetchHistory();

      setShowModal(false);

      alert("Deleted Successfully");

    } catch (err) {

      console.log(err);

      alert("Delete Failed");

    }

    setSaving(false);

  };

  return (
    <>
      <AdminHeader />

      <Container fluid="lg" className="py-4">

        <div className="mb-4">
          <h2>History</h2>

          <blockquote>
            View and manage previously saved numbers.
          </blockquote>
        </div>

        {/* Stats */}

        <Row className="g-4 mb-4">

          <Col md={4}>
            <Card className="border-0 shadow">
              <Card.Body>

                <small className="text-muted">
                  Current Year
                </small>

                <h3>{year}</h3>

              </Card.Body>
            </Card>
          </Col>

          <Col md={4}>
            <Card className="border-0 shadow">
              <Card.Body>

                <small className="text-muted">
                  Current Month
                </small>

                <h3 className="text-capitalize">
                  {month}
                </h3>

              </Card.Body>
            </Card>
          </Col>

          <Col md={4}>
            <Card className="border-0 shadow">
              <Card.Body>

                <small className="text-muted">
                  Total Records
                </small>

                <h3>{records.length}</h3>

              </Card.Body>
            </Card>
          </Col>

        </Row>

        {/* Filters */}

        <Card className="border-0 shadow mb-4">

          <Card.Body>

            <Row className="g-3">

              <Col md={4}>
                <Form.Label>
                  Year
                </Form.Label>

                <Form.Control
                  type="number"
                  value={year}
                  onChange={(e) =>
                    setYear(e.target.value)
                  }
                />
              </Col>

              <Col md={4}>
                <Form.Label>
                  Month
                </Form.Label>

                <Form.Select
                  value={month}
                  onChange={(e) =>
                    setMonth(e.target.value)
                  }
                >
                  {months.map((m) => (
                    <option
                      key={m.value}
                      value={m.value}
                    >
                      {m.label}
                    </option>
                  ))}
                </Form.Select>
              </Col>

              <Col md={4}>
                <Form.Label>
                  Search
                </Form.Label>

                <Form.Control
                  placeholder="Date / Number"
                  value={search}
                  onChange={(e) =>
                    setSearch(e.target.value)
                  }
                />
              </Col>

            </Row>

          </Card.Body>

        </Card>

        {/* Table */}

        {/* <Card className="border-0 shadow">

          <Card.Body>

            <div className="d-flex justify-content-between align-items-center mb-3">

              <h4 className="mb-0">
                Records
              </h4>

              <small className="text-muted">
                Double Click Number To Edit
              </small>

            </div>

            <div className="table-responsive">

              <Table
                bordered
                hover
                className="align-middle"
              >

                <thead>

                  <tr>

                    <th width="120">
                      Date
                    </th>

                    <th>
                      Number
                    </th>

                    <th width="220">
                      Updated Time
                    </th>

                  </tr>

                </thead>

                <tbody>

                  {loading ?
                    <tr>
                      <td
                        colSpan="3"
                        className="text-center py-5"
                      >
                        Loading...
                      </td>
                    </tr>
                    :
                    filtered.length ?
                      filtered.map((item) => (
                        <tr key={item.day}>
                          <td>
                            {item.day}
                          </td>
                          <td
                            style={{
                              cursor: "pointer",
                              fontWeight: 700,
                              fontSize: 18,
                            }}
                            onDoubleClick={() => {
                              setSelected(item);
                              setEditNumber(item.value);
                              setShowModal(true);
                            }}
                          >
                            {item.value}
                          </td>
                          <td>
                            {
                              item.time
                                ?
                                item.time.toLocaleString("en-IN")
                                :
                                "--"
                            }
                          </td>
                        </tr>
                      ))
                      :
                      <tr>
                        <td
                          colSpan="3"
                          className="text-center py-5"
                        >
                          No Records Found
                        </td>
                      </tr>
                  }

                </tbody>

              </Table>

            </div>

          </Card.Body>

        </Card> */}

        <Card className="border-0 shadow">

          <Card.Body>

            <div className="d-flex justify-content-between align-items-center mb-4">

              <h4 className="mb-0">
                Monthly Records
              </h4>

              <small className="text-muted">
                Double Click Card To Edit
              </small>

            </div>

            {loading ? (

              <div className="text-center py-5">
                Loading...
              </div>

            ) : filtered.length ? (

              <Row className="g-3">

                {filtered.map((item) => (

                  <Col
                    key={item.day}
                    xs={6}
                    sm={4}
                    md={3}
                    lg={2}
                    xl={1}
                    style={{ width: "12.5%" }}
                  >

                    <Card
                      className="shadow-sm border-0 h-100"
                      style={{
                        cursor: "pointer",
                        transition: ".25s",
                      }}
                      onDoubleClick={() => {
                        setSelected(item);
                        setEditNumber(item.value);
                        setShowModal(true);
                      }}
                    >

                      <Card.Body className="text-center shadow">

                        <div className="d-flex gap-1 align-items-center justify-content-center">
                          <small className="text-muted">
                            Day
                          </small>
                          -
                          <span className="fw-bold inline">
                            {item.day}
                          </span>
                        </div>

                        <div
                          style={{
                            fontSize: 28,
                            fontWeight: 700,
                            color: "#198754",
                          }}
                        >
                          {item.value}
                        </div>

                        <small
                          className="text-muted d-block mt-2"
                          style={{
                            fontSize: 11,
                          }}
                        >
                          {item.time
                            ? item.time.toLocaleDateString()
                            : "--"}
                        </small>

                      </Card.Body>

                    </Card>

                  </Col>

                ))}

              </Row>

            ) : (

              <div className="text-center py-5">
                No Records Found
              </div>

            )}

          </Card.Body>

        </Card>


      </Container>

      {/* Modal */}

      <Modal
        centered
        show={showModal}
        onHide={() => setShowModal(false)}
      >

        <Modal.Header closeButton>

          <Modal.Title>
            Edit Number
          </Modal.Title>

        </Modal.Header>

        <Modal.Body>

          {selected && (

            <>

              <p className="mb-3">
                <strong>Date :</strong>{" "}
                {selected.day}{" "}{
                  months.find(
                    (m) => m.value === month
                  )?.label
                }{" "}{year}
              </p>

              <Form.Group>

                <Form.Label>
                  Number
                </Form.Label>

                <Form.Control
                  value={editNumber}
                  maxLength={2}
                  onChange={(e) => {

                    const value = e.target.value.replace(
                      /\D/g,
                      ""
                    );

                    setEditNumber(value);

                  }}
                />

              </Form.Group>

            </>

          )}

        </Modal.Body>

        <Modal.Footer>

          <Button
            variant="danger"
            disabled={saving}
            onClick={handleDelete}
          >
            Delete
          </Button>

          <Button
            variant="dark"
            disabled={saving}
            onClick={handleSave}
          >
            {
              saving
                ?
                "Saving..."
                :
                "Save Changes"
            }
          </Button>

        </Modal.Footer>

      </Modal>

    </>
  );
}

export default History;